import { render } from "./SubHeader.vue?vue&type=template&id=fdeef8f2&scoped=true"
import script from "./SubHeader.vue?vue&type=script&lang=js"
export * from "./SubHeader.vue?vue&type=script&lang=js"

import "./SubHeader.vue?vue&type=style&index=0&id=fdeef8f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdeef8f2"]])

export default __exports__